export default __webpack_public_path__ + "static/media/downArrow.8d0cae4e.svg";